import searchResultTranslator from '@/services/shared/searchResultTranslator.js';

export const resetSearchResults = (state) => {
  state.displaySearchResults = false;
  state.searchResults = [];
  state.searchType = undefined;
};

export const setSearchResult = (state, { searchResult, searchType }) => {
  state.displaySearchResults = true;
  state.searchType = searchType;
  state.searchResults = searchResultTranslator.translateResults(searchResult.results, searchType);
  state.moreSearchResults = searchResult.more;
};

export const addToSearchHistory = (state, lastSearch) => {
  if (state.searchHistory.length > 2) state.searchHistory.shift();
  state.searchHistory.push(lastSearch);
};

export const clearSearch = (state) => {
  resetSearchResults(state);
  state.searchHistory = [];
};
